<template lang="pug">
#admin_container.container-small
  h1#container_title 연혁 관리 글쓰기
  .container_wr
    #s41.sub
      .inner
        .total_board_view_wrap.board_table
          table.guest_table.req_table
            colgroup
              col(width="120px")
              col(width="160px")
              col(width="120px")
              col
            tbody
              tr
                th 언어
                td(colspan='3')
                  select.nation_sel(v-model='args.nation')
                    option(value='kr') 한국어
                    option(value='en') 영어
              tr
                th 날짜
                td(colspan='3')
                  date-picker.month_picker(v-model="args.date" type='month' value-type="format" format="YYYY-MM" placeholder="Select date" :lang='lang')
              tr
                th.th_btn
                  span.req_sp 내용
                  button.btn02(@click="plusRow()") 추가
                td(colspan='3')
                  .con_btn(v-for="(text, idx) in content" :key="idx")
                    input.frm_input.full_input(type="text" v-model="content[idx]")
                    button.rmv.btn01(@click="removeRow(idx)") 삭제
          .board_btn 
            button#btn_submit(@click='postData()') 확인
            button#btn_list(@click='$_goTo({name: "history-admin"})') 목록

    
</template>

<script>
import { mapGetters } from 'vuex';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      content: [''],
      args: {
        nation: 'kr',
        date: '',
        content: [],
      },
      lang: {
        months: [
          '1월',
          '2월',
          '3월',
          '4월',
          '5월',
          '6월',
          '7월',
          '8월',
          '9월',
          '10월',
          '11월',
          '12월',
        ],
      },
    };
  },
  computed: {
    ...mapGetters(['checkAdminPage']),
  },
  methods: {
    postData() {
      if (this.args.date == '') {
        alert('날짜를 입력해주세요.');
      } else if (this.content.length == 1 && this.content[0] == '') {
        alert('내용을 입력해주세요.');
      } else {
        let noEmptyElements = this.content.every(el => el);
        if (noEmptyElements) {
          this.args.date = this.$moment(this.args.date).format(
            'YYYY-MM-DD HH:mm:ss',
          );
          this.args.content = this.content.join(',');
          this.$_admin_post('admin/history/post', this.args)
            .then(res => {
              if (res) {
                alert('작성이 완료되었습니다.');
                this.$_goTo({ name: 'history-admin' });
              } else {
                alert('작성에 실패하였습니다.');
                return;
              }
            })
            .catch(() => {});
        } else {
          alert('비어있는 내용의 칸을 삭제해주세요.');
        }
      }
    },
    async getData() {
      await this.$_admin_get('admin/history/detail', {
        nation: this.args.nation,
        idx: this.args.idx,
      })
        .then(res => {
          this.res = res.data.res[0];
        })
        .catch(() => {});
    },
    async getNextPrev() {
      await this.$_admin_get('admin/history/nextprev', {
        nation: this.args.nation,
        idx: this.args.idx,
      })
        .then(res => {
          this.nextprev = res.data.res;
        })
        .catch(() => {});
    },
    delData() {
      this.$_axios('PUT', 'admin/history/del', {
        nation: this.args.nation,
        idx: this.args.idx,
      })
        .then(() => {
          this.$_goTo({ name: 'history-admin' });
        })
        .catch(() => {});
    },

    plusRow() {
      this.content.push('');
    },
    removeRow(row) {
      if (this.content.length == 1) {
        alert('더이상 삭제할 수 없습니다.');
        return;
      }
      this.content.splice(row, 1);
    },
  },
  beforeMount() {},
  mounted() {
    this.args.nation = this.checkAdminPage.history[1];
  },
  created() {},
};
</script>

<style scoped>
@import '../../../assets/css/admin.css';
@import '../../../assets/css/board.css';
.board_list {
  clear: both;
  width: 100%;
  margin: 16px 0;
  border-top: 1px solid #aaa;
  border-bottom: 1px solid #aaa;
  border-top: 2px solid #1f1f1f;
}
.board_list th {
  background: #fafafa;
  font-weight: normal;
  text-align: center;
  border-bottom: 1px solid #e8e8e8;
  height: 46px;
  color: #333;
}
.board_list td.subject {
  text-align: left;
}
.board_list td.subject a {
  margin-left: 20px;
}
.board_list td {
  border-bottom: 1px solid #eee;
  height: 40px;
  text-align: center;
}
table td {
  line-height: 22px;
}
#s41.sub {
  padding: 0;
  padding-top: 30px;
}

.edit_btn {
  margin-top: 50px;
}
.board_button {
  clear: both;
  text-align: right;
  margin-bottom: 10px;
}
.board_button a {
  font-size: 13px;
  display: inline-block;
  padding: 10px 25px;
  border: 1px solid #ddd;
  line-height: 100%;
  margin-left: 5px;
  background: #fff;
}
.board_button a.newb {
  background: #2c2c2c;
  color: #fff;
  cursor: pointer;
}
em img {
  margin-right: 13px;
}
</style>
